export type ExclusiveDropdown = { closeImmediate: () => void };

export const exclusiveGroups = new Map<string, Set<ExclusiveDropdown>>();
